import * as enums from "../../../util/enums.js";
import { generateListenerId } from "../../../util/listenerIds.js";

export class SharedMediaManager {
    mediaMessageListenerId = generateListenerId("media_message");
    mediaMessageRequest = null;

    constructor(item, type, messagetype) {
        const CometChat = window.CometChat;
        if (!CometChat) {
            throw new Error('CometChat not initialized');
        }

        if (type === "user") {
            this.mediaMessageRequest = new CometChat.MessagesRequestBuilder()
                .setUID(item.uid)
                .setLimit(10)
                .setCategory("message")
                .setType(messagetype)
                .build();
        } else {
            this.mediaMessageRequest = new CometChat.MessagesRequestBuilder()
                .setGUID(item.guid)
                .setLimit(10)
                .setCategory("message")
                .setType(messagetype)
                .build();
        }
    }

    fetchPreviousMessages() {
        return this.mediaMessageRequest.fetchPrevious();
    }

    attachListeners(callback) {
        const CometChat = window.CometChat;
        if (!CometChat) return;

        CometChat.addMessageListener(
            this.mediaMessageListenerId,
            new CometChat.MessageListener({
                onMediaMessageReceived: (mediaMessage) => {
                    callback(enums.MEDIA_MESSAGE_RECEIVED, mediaMessage);
                },
                onMessageDeleted: (deletedMessage) => {
                    callback(enums.MESSAGE_DELETED, deletedMessage);
                },
            })
        );
    }

    removeListeners() {
        const CometChat = window.CometChat;
        if (!CometChat) {
            return;
        }
        CometChat.removeMessageListener(this.mediaMessageListenerId);
    }
}
